<template>
  <van-popup v-model="show" :overlay="false" :duration="!show ? '0.2' : '0.6'" position="left" :lazy-render="false">
    <img class="bg" src="@/assets/images/popup-bg.png" alt="">
    <div class="content">
      <div class="close" @click="show = false"></div>
      <div class="menu">
        <div class="item menuWow fadeInLeft" data-wow-duration="1.5s" :data-wow-delay="`${index * 0.4}s`"
          v-for="(item, index) in menu" @click="$router.push({ path: '/index/list?type=' + item.type })">
          <img :src="require(`@/assets/images/${item.icon}`)" alt="">
        </div>
      </div>
      <img class="add" src="@/assets/images/add@2x.png" alt="">
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      show: false,
      menu: [{
        icon: 'w@2x.png',
        type: 1,
      }, {
        icon: 'a@2x.png',
        type: 2,
      }, {
        icon: 'n@2x.png',
        type: 3,
      }, {
        icon: 's@2x.png',
        type: 4,
      }]
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$wow('menuWow');
      }
    }
  },
  computed: {},
  methods: {},
  created() { },
  mounted() { }
}
</script>
<style scoped>
.van-popup {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #fff0;
}

.van-popup .bg {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  min-height: 14.97rem;
  height: 100vh;
}

.content {
  position: relative;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.content .close {
  width: 1.03rem;
  height: .32rem;
  background-image: url(~@/assets/images/close.png);
  background-size: 100% 100%;
  margin-top: .46rem;
  margin-left: .46rem;
}

.menu {
  margin-top: .48rem;
}

.menu .item {
  width: 2.31rem;
  height: .44rem;
  margin-left: .46rem;
  margin-bottom: .9rem;
}

.menu .item img {
  width: 100%;
  height: 100%;

}

.add {
  position: absolute;
  left: .45rem;
  bottom: .42rem;
  width: 3.77rem;
  height: .94rem;
}
</style>